import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useSelectedLanguage from 'store/language';
import useWebsiteSports, { SportProviders } from 'store/websiteSports';

const SportSwissWidget = () => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const navigate = useNavigate();
  const [{ selectedLanguage }] = useSelectedLanguage();
  const [, { addSoftSwissPostFix }] = useWebsiteSports();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isLoaded) return;

    const handler = (event: MessageEvent) => {
      if (event.origin === 'https://ss1.usportframe.com') {
        switch (event.data.type) {
          case 'sportsbook:top-event-clicked':
            addSoftSwissPostFix(
              `/${event.data.payload.sportKey}/${event.data.payload.matchSlug}-m-${event.data.payload.matchId}`
            );
            navigate(`/sport/${SportProviders.SOFT_SWISS_ID}`);
            break;
          default:
            break;
        }
      }
    };

    window.addEventListener('message', handler);

    return () => {
      window.removeEventListener('message', handler);
    };
  }, [isLoaded]);

  return (
    <iframe
      onLoad={() => setIsLoaded(true)}
      style={{
        width: '100%',
        border: 'none',
        height: '170px',
      }}
      ref={ref}
      src={`https://ss1.usportframe.com/${selectedLanguage?.iso_1}/top-events`}
    />
  );
};

export default SportSwissWidget;
